var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    { on: { onUserUpdate: _vm.onUserUpdate } },
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "my-2 ml-1 mr-1",
                      attrs: { "align-h": "between" }
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: { click: _vm.showAddUser }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("buttons.add")) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mr-1" },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-form",
                                { staticClass: "mr-2", attrs: { inline: "" } },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      block: "false",
                                      placeholder: "filter"
                                    },
                                    model: {
                                      value: _vm.filter,
                                      callback: function($$v) {
                                        _vm.filter = $$v
                                      },
                                      expression: "filter"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    variant: "secondary",
                                    href: "/api/v1/users/export"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("buttons.export")) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    right: "",
                                    text: _vm.$t("buttons.columns"),
                                    variant: "secondary"
                                  }
                                },
                                [
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn("Email")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown: _vm.config["Email"].visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("table.headers.email")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn("FullName")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown:
                                              _vm.config["FullName"].visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("table.headers.name")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn("Country")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown: _vm.config["Country"].visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("table.headers.country")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn(
                                            "CompanyName"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown:
                                              _vm.config["CompanyName"].visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("table.headers.company")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn("RoleID")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown: _vm.config["RoleID"].visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("table.headers.roleid")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn("Created")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown: _vm.config["Created"].visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("table.headers.created")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn(
                                            "Limits.MaxCredits"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown:
                                              _vm.config["Limits.MaxCredits"]
                                                .visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "table.headers.maxcredits"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn(
                                            "Limits.MinTime"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown:
                                              _vm.config["Limits.MinTime"]
                                                .visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("table.headers.mintime")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn(
                                            "Limits.MaxTime"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown:
                                              _vm.config["Limits.MaxTime"]
                                                .visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("table.headers.maxtime")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn(
                                            "ReferenceUser.ReferenceUsername"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown:
                                              _vm.config[
                                                "ReferenceUser.ReferenceUsername"
                                              ].visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "table.headers.referenceusername"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.togggleColumn("Actions")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            shown: _vm.config["Actions"].visible
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("table.headers.actions")
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      items: _vm.users,
                      small: "",
                      fields: _vm.tableConfiguration,
                      responsive: "xl",
                      filter: _vm.filter,
                      "sort-compare": _vm.sortCompareAdvanced
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "head(Email)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.email")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(FullName)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.name")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(Country)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.country")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(CompanyName)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.company")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(RoleID)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.roleid")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(Created)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.created")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(Limits.MinTime)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.mintime")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(Limits.MaxTime)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.maxtime")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(Limits.MaxCredits)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.maxcredits")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(ReferenceUser.ReferenceUsername)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("table.headers.referenceusername")
                                ) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "head(Action)",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("table.headers.actions")) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(RoleID)",
                        fn: function(data) {
                          return [
                            data.item.RoleID === 0
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "form.options.permissions.ellipseadmin"
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            data.item.RoleID === 10
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "form.options.permissions.ellipsetech"
                                      )
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            data.item.RoleID === 20
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "form.options.permissions.creditdistributor"
                                      )
                                    )
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "cell(FullName)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.item.FirstName) +
                                " " +
                                _vm._s(data.item.MiddleName) +
                                " " +
                                _vm._s(data.item.LastName) +
                                "\n          "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(Actions)",
                        fn: function(data) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "dark" },
                                on: {
                                  click: function($event) {
                                    return _vm.showEditUser(data)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("buttons.edit")) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "danger" },
                                on: {
                                  click: function($event) {
                                    return _vm.verifyDeleteUser(data)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("buttons.delete")) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(Created)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.parseDate(data.item.Created)) +
                                "\n          "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteUserConfirm",
          attrs: { "hide-footer": "", title: _vm.$t("form.title.delete") }
        },
        [
          _c("div", { staticClass: "d-block text-center" }, [
            _c("h6", [
              _vm._v(
                _vm._s(_vm.$t("form.texts.delete", { email: this.user.Email }))
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mt-3",
              attrs: { variant: "outline-danger", block: "" },
              on: {
                click: function($event) {
                  return _vm.deleteUser(_vm.user)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("buttons.delete")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("user-modal", {
        attrs: {
          "modal-action": _vm.modalAction,
          visible: _vm.showUserDialog,
          user: _vm.user
        },
        on: {
          "update:visible": function($event) {
            _vm.showUserDialog = $event
          },
          "update:user": function($event) {
            _vm.user = $event
          },
          success: _vm.onSuccess
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e53b7b3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e53b7b3","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./WebApp/components/Users.vue
// module id = 769
// module chunks = 0